import React, { useReducer, useContext, useEffect, useState } from 'react';
import Breadcrumb from '../../shared/Breadcrumb';
import Util from '../../../Util';
import { AuthContext } from '../../../contexts/AuthContext';
import { Link, useHistory } from 'react-router-dom';
import { apiRoutes } from '../../../AppSettings';
import axios from 'axios';
import PatientInfo from './PatientInfo';
import alertify from "alertifyjs";


const LOAD_ITEMS = "LOAD_ITEMS";
const UPDATE_APPOINMENT = "UPDATE_APPOINMENT";
const SET_INVOICE_ID = "SET_INVOICE_ID"; 
const LOAD_PRESCRIPTIONS = "LOAD_PRESCRIPTIONS";
const SET_PRESCRIPTION = "SET_PRESCRIPTION";
const SET_VIDEOCALL = "SET_VIDEOCALL";
const SET_VOICECALL = "SET_VOICECALL";
const SET_FEES = "SET_FEES";

const itemsInitialValue = {
	invoiceItemId: 0,
	description: '',
	quantity: 1,
	amount: 0
};

const initialValue = {
	invoiceItem: [itemsInitialValue],
    selectedAppoinmentId: 0,
    invoiceId: 0,
    prescriptions: [],
    selectedPrescription: {},
    videoCallSelected: false,
    voiceCallSelected: false,
    fees: {
        consultingFee: 0,
        bookingFee: 0,
        videoCallFee: 0
    }
}

const reducer = (state, action) => {
	switch(action.type)
	{
		case LOAD_ITEMS:
			return { ...state, invoiceItem: action.item };
		case UPDATE_APPOINMENT:
            return { ...state, selectedAppoinmentId: action.selectedAppoinmentId };
        case SET_INVOICE_ID:
            return { ...state, invoiceId: action.invoiceId };
        case LOAD_PRESCRIPTIONS:
            return { ...state, prescriptions: action.prescriptions };
        case SET_PRESCRIPTION:
            return { ...state, selectedPrescription: action.selectedPrescription };
        case SET_VIDEOCALL:
            return { ...state, videoCallSelected: action.videoCallSelected };
        case SET_VOICECALL:
            return { ...state, voiceCallSelected: action.voiceCallSelected };
        case SET_FEES: 
            return { ...state, fees: action.fees };
        default:
            return state; 
	} 
}


const AddBilling = (props) => {
    const invoiceId = JSON.parse(props.location.state.invoiceId);
    const doctor = JSON.parse(props.location.state.doctor);
	const patient = JSON.parse(props.location.state.patient);
    const appoinments = JSON.parse(props.location.state.appoinments);
    
    const [state, dispature] = useReducer(reducer, initialValue);

    const [inventory, setInventory] = useState([]);
	const [services, setServices] = useState([]);
    const [voiceCallFee, setVoiceCallFee] = useState(0);
    const [videoCallFee, setVideoCallFee] = useState(0);

    const { userState } = useContext(AuthContext);
    const history = useHistory();

    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
	};
    
    useEffect(() => {
        console.log(doctor)
        if(appoinments.length == 1)
		{
            loadPrescription(appoinments[0].appoinmentId);
			dispature({type: UPDATE_APPOINMENT, selectedAppoinmentId: appoinments[0].appoinmentId});
		}

		if(invoiceId != undefined && invoiceId != 0 ) {
			handleDelete();
			axios.get(apiRoutes.getInvoiceById + invoiceId, options)
			.then((response) => {
			  if(response.status === 200)
			  {
				  const data = response.data;
				  console.log(data.appoinment.appoinmentId);
				  dispature({type: SET_INVOICE_ID, invoiceId: data.invoiceId });
				  dispature({type: LOAD_ITEMS, item: data.invoiceItems});
				  dispature({type: UPDATE_APPOINMENT, selectedAppoinmentId: data.appoinment.appoinmentId});
			  }
			}, (error) => {
			  console.log(error);
		  });
        }

        axios.get(apiRoutes.getVisitingCharges + doctor.doctorId,  options)
        .then((response) => {
            if(response.status === 200)
            {
                const data = response.data.data;
                console.log({bookingFee: data.bookingFee, consultingFee: data.consultingFee, videoCallFee: data.videoCallFee});
              //  setInventory(data);
                dispature({type: SET_FEES, fees: { bookingFee: data.bookingFee, consultingFee: data.consultingFee, videoCallFee: data.videoCallFee}})
            }
            }, (error) => {
            console.log(error);
        });

        
        axios.get(apiRoutes.GetAllInventory,  options)
			.then((response) => {
			  if(response.status === 200)
			  {
				  const data = response.data;
				  console.log(data);
				  setInventory(data);
			  }
			}, (error) => {
			  console.log(error);
		  });

		axios.get(apiRoutes.GetAllService,  options)
		  .then((response) => {
			if(response.status === 200)
			{
				const data = response.data;
				console.log(data);
				setServices(data);
			}
		  }, (error) => {
			console.log(error);
        });
        
        axios.get(apiRoutes.LoadSetting, options)
        .then((response) => {
            if(response.status === 200)
            {
                const data = response.data;
                if(data.voiceCallFee != undefined)
                {
                    setVoiceCallFee(data.voiceCallFee);
                }
                if(data.videoCallFee != undefined)
                {
                    setVideoCallFee(data.videoCallFee);
                }
            }
        }, (error) => {
          console.log(error.response);
        });
	}, []);

    const handleOnChange = (e, idToChange, field) => {
		let value = e.target.value;

		state.invoiceItem.forEach(element => {
			if(element.invoiceItemId === idToChange)
				updateValues(element, field, value)
		})

		dispature({type: LOAD_ITEMS, item: state.invoiceItem})
	}

    const updateValues = (item, field, value) =>{
		switch(field)
		{
			case "title":
				item.description = value;
				break;
			case "quantity":
				item.quantity = value;
				break;
			case "amount":
				item.amount = value;
				break;
		}
	}

    const handleDelete = (id) => {
		dispature({type: LOAD_ITEMS, item: state.invoiceItem.filter((item) => item.invoiceItemId !== id)})
	}
    
    const handleAddMore = () => {
        let minId = 0;
		if(state.invoiceItem.length > 0) {
			minId =	Math.min.apply(Math, state.invoiceItem.map(function(o) { 
				return o.invoiceItemId;  
			})); 
		}
        
        minId = (minId >= 0 ? -1 : minId) - 1;

        let newItem = {
			invoiceItemId: minId,
			description: '',
			quantity: 1,
            amount: 0
    	}

		state.invoiceItem.push(newItem);

		dispature({type: LOAD_ITEMS, item: state.invoiceItem})
    }

    const handleSubmit = () => {
		if(state.selectedAppoinmentId == 0)
		{
            console.log('please select appoinment')
            alertify.error("please select appoinment");
            return;
        }
        
        var route = apiRoutes.createInvoice;
		if(invoiceId != undefined && invoiceId != 0)
		{
			route = apiRoutes.updateInvoice;
        }
        
        var invoiceRequest = {
            prescriptionId: state.selectedPrescription[0].prescriptionId,
            invoiceItem: state.invoiceItem,
            invoiceId: state.invoiceId,
            selectedAppoinmentId: state.selectedAppoinmentId
        }
        console.log(invoiceRequest);
		axios.post(route, JSON.stringify(invoiceRequest), options)
        .then((response) => {
            if(response.status === 200)
            {
                var data = response.data;
                console.log(response.data);
                dispature({type: SET_INVOICE_ID, invoiceId: data.result });
                alertify.success("Invoice added/updated successfully");

                history.push({
                    pathname:'/PatientProfile',
                    state: {
                        patientId: patient.patientId
                    }
                })
            }
        }, (error) => {
            console.log(error);
        });
    }
    
    const loadPrescription = (id) => {
        axios.get(apiRoutes.LoadPrescription + id, options)
        .then((response) => {
            if(response.status === 200)
            {
                const data = response.data;
                dispature({type: LOAD_PRESCRIPTIONS, prescriptions: data});
            }
        }, (error) => {
            console.log(error);
        });
    }

    const handlePrescriptionSelect = (prescriptionId) => {
        let selectedPrescription = state.prescriptions.filter((item) => item.prescriptionId == prescriptionId)
        state.invoiceItem = [];
        selectedPrescription[0].prescriptionItem.forEach(element => {
            let minId = 0;
            if(state.invoiceItem.length > 0) {
                minId =	Math.min.apply(Math, state.invoiceItem.map(function(o) { 
                    return o.invoiceItemId;  
                })); 
            }

            minId = (minId >= 0 ? -1 : minId) - 1;
            let totalAmount = 0;
            let selectedInventory = inventory.filter((item) => item.description == element.name)
            if(selectedInventory != undefined && selectedInventory.length > 0)
            {
                console.log(selectedInventory);
                totalAmount = selectedInventory[0].unitCost * element.quantity;
            }

            let newItem = {
                invoiceItemId: minId,
                description: element.name,
                quantity: element.quantity,
                amount: totalAmount
            }
    
            state.invoiceItem.push(newItem);
        });

        selectedPrescription[0].prescriptionService.forEach(element => {
            let minId = 0;
            if(state.invoiceItem.length > 0) {
                minId =	Math.min.apply(Math, state.invoiceItem.map(function(o) { 
                    return o.invoiceItemId;  
                })); 
            }

            minId = (minId >= 0 ? -1 : minId) - 1;
            console.log(services);
         
            let totalAmount = 0;
            let selectedService = services.filter((item) => item.name == element.serviceName)
            if(selectedService != undefined && selectedService.length > 0)
            {
                console.log(selectedService);
                totalAmount = selectedService[0].cost;
            }

            let newItem = {
                invoiceItemId: minId,
                description: element.serviceName,
                quantity: 1,
                amount: totalAmount
            }
    
            state.invoiceItem.push(newItem);
        });
       
        dispature({type: LOAD_ITEMS, item: state.invoiceItem})


        dispature({type: SET_PRESCRIPTION, selectedPrescription: selectedPrescription })
    }


    const handleOnVideoChange = () => {
        state.videoCallSelected = !state.videoCallSelected;
        let items = state.invoiceItem.filter((item) => item.description.toLowerCase() == "video call")

        if(state.videoCallSelected && items != undefined && items.length == 0)
        {
            let minId = 0;
            if(state.invoiceItem.length > 0) {
                minId =	Math.min.apply(Math, state.invoiceItem.map(function(o) { 
                    return o.invoiceItemId;  
                })); 
            }

            minId = (minId >= 0 ? -1 : minId) - 1;

            let newItem = {
                invoiceItemId: minId,
                description: "Video Call",
                quantity: 1,
                amount: videoCallFee
            }

            state.invoiceItem.push(newItem);
            dispature({type: LOAD_ITEMS, item: state.invoiceItem})
        } else {
            dispature({type: LOAD_ITEMS, item: state.invoiceItem.filter((item) => item.description.toLowerCase() != "video call")})
        }
        
      
        dispature({type: SET_VIDEOCALL, videoCallSelected: state.videoCallSelected})
    }

    const handleOnVoiceChange = () => {

        state.voiceCallSelected = !state.voiceCallSelected;
        let items = state.invoiceItem.filter((item) => item.description.toLowerCase() == "voice call")

        if(state.voiceCallSelected && items != undefined && items.length == 0)
        {
            let minId = 0;
            if(state.invoiceItem.length > 0) {
                minId =	Math.min.apply(Math, state.invoiceItem.map(function(o) { 
                    return o.invoiceItemId;  
                })); 
            }

            minId = (minId >= 0 ? -1 : minId) - 1;

            let newItem = {
                invoiceItemId: minId,
                description: "Voice Call",
                quantity: 1,
                amount: voiceCallFee
            }

            state.invoiceItem.push(newItem);
            dispature({type: LOAD_ITEMS, item: state.invoiceItem})
        } else {
            dispature({type: LOAD_ITEMS, item: state.invoiceItem.filter((item) => item.description.toLowerCase() != "voice call")})
        }
        

        dispature({type: SET_VOICECALL, voiceCallSelected: state.voiceCallSelected})
    }

    return (  
        <div>
            <Breadcrumb title={invoiceId != undefined && invoiceId != 0 ? "Edit Billing" : "Add Billing" } />
            <div className="content">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <PatientInfo patient={patient}></PatientInfo>
    					</div>

						<div className="col-md-7 col-lg-8 col-xl-9">
							<div className="card">
								<div className="card-header">
									<h4 className="card-title mb-0">{invoiceId != undefined && invoiceId != 0 ? "Edit" : "Add" } Billing</h4>
								</div>
								<div className="card-body">
                                   <form onSubmit={e => {e.preventDefault(); handleSubmit();}}>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="biller-info">
                                                    <h4 className="d-block">Dr. {doctor.firstName} {doctor.lastName}</h4>
                                                    <span className="d-block text-sm text-muted">{doctor.category}</span>
                                                    <span className="d-block text-sm text-muted">{doctor.state}, {doctor.country}</span>
                                                </div>
                                                <div className="form-group">
                                                    <label>Appoinment: </label>
                                                    {
														appoinments.length > 1 ? <select className="select form-control" value={state.selectedAppoinmentId} 
																					onChange={(e) => { dispature({type: UPDATE_APPOINMENT, selectedAppoinmentId: e.target.value}); loadPrescription(e.target.value) }}
																					>
																						<option></option>
																						{
																							appoinments.map(item => (
																								<option selected={true} key={item.appoinmentId} value={item.appoinmentId}>{item.appoinmentNumber}</option>
																							))
																						}
																					</select>
																				: 
																				<div> <strong>{appoinments[0].appoinmentNumber}</strong></div>
																					
													}

                                                </div>
                                            </div>
                                            <div className="col-sm-6 text-sm-right">
                                                <div className="billing-info">
                                                    <h4 className="d-block">{Util.getFormatDate({date: (new Date())})}</h4>
                                                    <span className="d-block text-muted"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                {
                                                    state.prescriptions.length > 0 && <div style={{marginBottom: '5px'}}>Select Prescriptions</div>
                                                }
                                                {
                                                    state.prescriptions.map(p => (
                                                        <div key={p.prescriptionId}>
                                                            <div style={{marginLeft: '20px'}}><input className="form-check-input" type="radio" name="prescription" onChange={(e) => handlePrescriptionSelect(p.prescriptionId) } /> {p.name}</div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <div className="col-sm-6 text-sm-right">
                                                <div className="form-check form-check-inline">
                                                    <label className="form-check-label">
                                                        <input className="form-check-input" type="checkbox" onChange={handleOnVideoChange} /> Video Call
                                                    </label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <label className="form-check-label">
                                                        <input className="form-check-input" type="checkbox" onChange={handleOnVoiceChange}/> Voice Call
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="add-more-item text-right">
                                            <a onClick={e=>handleAddMore(e)}><i className="fas fa-plus-circle"></i> Add Item</a>
                                        </div>
                                        <div className="card card-table">
                                            <div className="card-body">
                                                <div className="table-responsive">
                                                    <table className="table table-hover table-center">
                                                        <thead>
                                                            <tr>													
                                                                <th style={{minWidth: "200px"}}>Title</th>					
                                                                <th style={{minWidth: "80px"}}>Quantity</th>		
                                                                <th style={{minWidth: "200px"}}>Amount</th>		
                                                                <th style={{minWidth: "80px"}}></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                state.invoiceItem != undefined &&
                                                                state.invoiceItem.map(item => (
                                                                    <tr key={item.invoiceItemId}>								
                                                                        <td>	
                                                                            <input type="text" required className="form-control" required value={item.description} onChange={e => handleOnChange(e, item.invoiceItemId, 'title')} />
                                                                        </td>
                                                                        <td>
                                                                            <input className="form-control" type="text" required value={item.quantity} onChange={e => handleOnChange(e, item.invoiceItemId, 'quantity')}/>
                                                                        </td>
                                                                        <td>
                                                                            <input type="text" required className="form-control" required value={item.amount} onChange={e => handleOnChange(e, item.invoiceItemId, 'amount')}/>
                                                                        </td>							
                                                                        <td>
                                                                            <a onClick={() => handleDelete(item.invoiceItemId) }  className="btn bg-danger-light trash"><i className="far fa-trash-alt"></i></a>															
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 text-right">
                                                <div className="signature-wrap">
                                                    <div className="signature">
                                                        {doctor.firstName} {doctor.lastName}
                                                    </div>
                                                    <div className="sign-name">
                                                        <p className="mb-0">( Dr. {doctor.firstName} {doctor.lastName} )</p>
                                                        <span className="text-muted">Signature</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="submit-section">
                                                    <button type="submit" className="btn btn-primary submit-btn">Save</button>
                                                    <Link className="btn btn-secondary submit-btn" 
                                                        to={
                                                            {
                                                                pathname:'/PatientProfile',
                                                                state: {
                                                                    patientId: patient.patientId
                                                                }
                                                            }
                                                    }>Cancel</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>		
        </div>
    );
}
 
export default AddBilling;